<div class="footer">
    <div class="d-flex">
      <div><img src="../assets/logo/willistowerswatson-logo.svg"></div>
      <small class="footer-copyright ml-auto">&copy; Copyright 2019 Willis Towers Watson</small>
    </div>
  </div>